import {useTranslation} from 'react-i18next';

import {Box, TextField, useTheme} from '@mui/material';

import {InfoBanner} from '../../../../../../components/InfoBanner/InfoBanner';
import {getFieldStyle} from '../../../../../../layouts/theme/FieldStyles';


export interface Props {
  summary: string;
  onSummaryChange: (value: string) => void;
}

export const WorkforceProfileWizardSummaryStep = ({summary, onSummaryChange}: Props) => {
  const theme = useTheme();
  const {t} = useTranslation('translation', {keyPrefix: 'workforceProfilesPage.wizard.sections.summary'});

  return (
    <Box>
      <InfoBanner text={t('guidance')} sx={{mb: 2}} />
      <TextField
        fullWidth
        multiline
        minRows={4}
        size='small'
        label={t('label')}
        value={summary}
        onChange={(event) => onSummaryChange(event.target.value)}
        sx={getFieldStyle(theme)}
      />
    </Box>
  );
};
